// extracted by mini-css-extract-plugin
export default {"link":"Link-module--link--vbivY"};